import type { Definition } from '@exodus/dependency-types';

import { getIsFeatureEnabled } from '@/utils/app-config.js';
import type { Analytics } from '../types.js';

type Dependencies = {
  analytics: Analytics;
};

const createAnalyticsAppConfigPlugin = ({ analytics }: Dependencies) => {
  const onUnlock = () => {
    const isAppsDisplayed = __STANDALONE_MODE__;
    const isCollectiblesDisplayed = getIsFeatureEnabled('collectibles');
    const isFiatDisplayed = getIsFeatureEnabled('fiat');
    const isSwapDisplayed = getIsFeatureEnabled('swaps');

    analytics.setDefaultEventProperties({
      isAppsDisplayed,
      isCollectiblesDisplayed,
      isFiatDisplayed,
      isSwapDisplayed,
    });
  };

  return {
    onUnlock,
  };
};

const analyticsAppConfigPluginDefinition = {
  id: 'analyticsAppConfigPlugin',
  type: 'plugin',
  factory: createAnalyticsAppConfigPlugin,
  dependencies: ['analytics'],
} as const satisfies Definition;

export default analyticsAppConfigPluginDefinition;
